import { surveyInstance } from '..';

const addSurvey = async (data) => {
  await surveyInstance.post('/survey/', data);
};

export default addSurvey;
